import React from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'react-bootstrap'

const AlertModal = (props) => {
  const onHide = (e) => {
    e.stopPropagation()
    e.preventDefault()

    props.close()
  }

  const { message, show, title } = props

  return (
    <Modal show={show} onHide={onHide} backdrop={false} className="alert-modal">
      <Modal.Header closeButton>
        <Modal.Title> {title} </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {message &&
          message.split('\n').map((text, i) => (
            <p key={i} className="confirmation-text">
              {' '}
              {text}{' '}
            </p>
          ))}
      </Modal.Body>

      <Modal.Footer>
        <button className="button-neutral" onClick={onHide}>
          OK
        </button>
      </Modal.Footer>
    </Modal>
  )
}

AlertModal.propTypes = {
  message: PropTypes.string,
  show: PropTypes.bool,
  title: PropTypes.string,

  close: PropTypes.func,
}

export default AlertModal
